export {authAreaPluggable} from './lib/auth-area.pluggable';
